export const throttleError = 'throttleError'
export const closeStripeError = 'closeStripeError'

const readableError = (err: string) => err.split(' (')[0]?.replace('Firebase: ', '')

export const toast = (err?: any) => {
  if (err?.response?.data?.message) {
    alert(err.response.data.message)
  } else if (err?.message) {
    if (err.message !== closeStripeError && err.message !== throttleError) {
      alert(readableError(err.message))
    }
  } else if (err) {
    alert(err)
  } else {
    alert('Something went wrong!')
  }
}
